//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from "@/components/profile/mixins/ProfileData"

export default {

    name: 'KeyFactsFairs',

    mixins: [ProfileData],

    props: {
        fairs: {
        }
    }

}

